import { logError } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import reduxCatch from 'redux-catch';

// @ts-expect-error ts-migrate(7006): Suppressed to be able to turn on strict mode. Do not copy.
const errorHandler = (error, _getState, lastAction, _dispatch) => {
  logError({
    component: 'state',
    error,
    message: `Error parsing action type: ${lastAction.type}`,
    stacktrace: error.stack || error.backtrace || error.stacktrace,
  });
};

export const errorLogging = reduxCatch(errorHandler);
